import { render, staticRenderFns } from "./exhibitionIntroduce.vue?vue&type=template&id=0141aa7c&scoped=true"
import script from "./exhibitionIntroduce.vue?vue&type=script&lang=js"
export * from "./exhibitionIntroduce.vue?vue&type=script&lang=js"
import style0 from "./exhibitionIntroduce.vue?vue&type=style&index=0&id=0141aa7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0141aa7c",
  null
  
)

export default component.exports